/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import PDFViewer from "mgr-pdf-viewer-react";
import printJS from "print-js";
import useDownloadFile from "./useDownloadFile";
import { useEmpresa } from "../../layout/EmpresaProvider";
import alerts from "../alerts";

const uri = process.env.REACT_APP_API_URL;

const PdfViewer = ({
    header,
    value,
    urlApi,
    descargar,
    visible,
    hide,
    showApprove,
    onApprove,
    onReject,
    onReview,
    revisar = false
}) => {

    const [document, setDocument] = useState({});
    const downloadFile = useDownloadFile();
    const pdfContainerRef = useRef(null);

    const { empresaId } = useEmpresa();

    useEffect(() => {
        if (value != null) {
            if (value.file != null) {
                setDocument({ file: value.file });
            } else {
                setDocument({ url: `${uri}/archivos/descargar/${empresaId}?url=${value.url}` });
            }
        } else {
            setDocument({ url: `${uri}/${urlApi}` });
        }

    }, [visible, value, urlApi]);

    function getWidth() {
        if (window.innerWidth < 768)
            return "75vw";
        if (window.innerWidth < 1000)
            return "55vw";
        return "35vw";
    }

    const handleDownload = () => {
        if (descargar != null) {
            descargar();
        } else {
            downloadFile(value);
        }
    };

    const approveHandler = async () => {
        if ((await alerts.preguntarSiNo("¿Desea aprobar el documento?")) === true) {
            onApprove();
        }
    };

    const rejectHandler = async () => {
        if ((await alerts.preguntarSiNo("¿Desea rechazar el documento?")) === true) {
            onReject();
        }
    };

    const copyImageHandler = async () => {
        try {
            const canvas = pdfContainerRef.current?.querySelector("canvas");

            if (!canvas) {
                alert("No se encontró la imagen del PDF para copiar.");
                return;
            }

            if (!navigator.clipboard || !window.ClipboardItem) {
                alert("Tu navegador no permite copiar imágenes al portapapeles.");
                return;
            }

            canvas.toBlob(async (blob) => {
                if (!blob) {
                    alert("No se pudo generar la imagen del PDF.");
                    return;
                }

                try {
                    const ClipboardItemConstructor = window.ClipboardItem;

                    await navigator.clipboard.write([
                        new ClipboardItemConstructor({
                            "image/png": blob
                        })
                    ]);

                    alert("Imagen copiada al portapapeles.");
                } catch (error) {
                    console.error(error);
                    alert("No se pudo copiar la imagen del PDF.");
                }

            }, "image/png");

        } catch (error) {
            console.error(error);
            alert("No se pudo copiar la imagen del PDF.");
        }
    };

    const footer = (
        <div className="mt-2">
            <Button label="Cerrar" className="p-button-outlined" onClick={hide} />
            <Button label="Descargar" onClick={handleDownload} />

            <Button
                label="Copiar Imagen"
                className="p-button-outlined"
                onClick={copyImageHandler}
            />

            {document.url != null &&
                <Button label="Imprimir" onClick={() => printJS(document.url)} />
            }

            {showApprove &&
                <>
                    <Button label="Aprobar" className="p-button-outlined p-button-success" onClick={approveHandler} />
                    <Button label="Rechazar" className="p-button-outlined p-button-danger" onClick={rejectHandler} />
                </>
            }

            {revisar &&
                <Button label="Solicitar Revisión" className="p-button-outlined p-button-success" onClick={onReview} />
            }
        </div>
    );

    return (
        <>
            <Dialog
                header={header}
                footer={footer}
                visible={visible}
                style={{ width: getWidth() }}
                modal
                onHide={hide}
            >
                <div
                    className="form-row"
                    ref={pdfContainerRef}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%"
                    }}
                >
                    <PDFViewer document={document} />
                </div>
            </Dialog>
        </>
    );
};

export default PdfViewer;